import React, {
  useContext,
  useEffect,
  useState,
  useMemo,
  useCallback,
} from "react";
import {
  Table,
  Divider,
  Popconfirm,
  Typography,
  Input,
  message,
  Modal,
  Button,
  Spin,
  Empty,
  Pagination,
} from "antd";
import {
  CheckCircleOutlined,
  CreditCardOutlined,
  DownloadOutlined,
} from "@ant-design/icons";
import moment from "moment";
import { ContextAPI } from "../../../../ContextAPI";
import { platformApi } from "../../../../api";
import WrappedAuthenticationData from "../BookingRegisterModal/AuthenticationData";
import GatepassModal from "../GatepassModal";
import GatePassOtpModal from "../../JobOrder/JobOrderModal/GatePassOtpModal";
import FinancerModal from "../FinancerModal";
import ExchangeModal from "../ExchangeModal";
import "../index.less";
import InsuranceModal from "../InsuranceModal";
import AddNumberPlating from "../../NumberPlating/AddNumberPlating";
import ChangeOrderStatusReceived from "../../NumberPlating/ChangeOrderStatusReceived";
import ChangeOrderStatusFixed from "../../NumberPlating/ChangeOrderStatusFixed";
import PaymentModal from "../PaymentModal";
import WrappedFeedbackCallModal from "../../JobOrder/JobOrderTable/FeedbackCallModal";
import RTODocumentModal from "../RTODocumentModal";
import LedgerModal from "../../Ledger/LedgerModal";
import PymidolBookingSyncModal from "./PymidolBookingSyncModal";
import { ENDPOINT } from "../../../../constants";
import { useHistory } from "react-router-dom";
import { baseUrl } from "../../../../api";
import VehicleName from "../../../VehicleName";

export default function BookingRegisterTable(props) {
  const {
    pagination,
    dataSource,
    openModal,
    openInvoiceModal,
    openChassisModal,
    spinner,
    onDelete,
    modify,
    deleteAccess,
    advancedBookingModifyAccess,
    updateDataStatus,
    type,
    isSales,
    invoiceStatus,
    mainData,
    refreshData,
    openPaymentModal,
    tab,
    printAccess = false,
    onBulkUpload,
    onForm14Download,
    onForm19Download,
  } = props;
  const { loginCredintials } = useContext(ContextAPI);

  const [openAuth, setOpenAuth] = useState(false);
  const [editable, setEditable] = useState(false);
  const [bookingData, setBookingData] = useState({});
  const [data, setData] = useState({});
  const [gatepassOpen, setGatepassOpen] = useState(false);
  const [insuranceOpen, setInsuranceOpen] = useState(false);
  const [authorization, setAuthorization] = useState(false);
  const isAuthorized = type === "authorized";
  const { Text } = Typography;
  const [reasons, setReasons] = useState({});
  const [financerModalOpen, setFinancerModalOpen] = useState(false);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [customerLedgerOpen, setCustomerLedgerOpen] = useState(false);
  const [financerData, setFinancerData] = useState({});
  const [exchangeModalOpen, setExchangeModalOpen] = useState(false);
  const [exchangeData, setExchangeData] = useState({});
  const [viewPaymentsOpen, setViewPaymentsOpen] = useState(false);
  const [
    viewCancellationPaymentsOpen,
    setViewCancellationPaymentsOpen,
  ] = useState(false);
  const [paymentModal, setPaymentModal] = useState(false);
  const [selectedPayments, setSelectedPayments] = useState([]);
  const [selectedCompanyPayments, setselectedCompanyPayments] = useState([]);
  const [viewCompanyPaymentsOpen, setViewCompanyPaymentsOpen] = useState(false);
  const [numberPlateModal, setNumberPlateModal] = useState(false);
  const [receiveNPO, setReceiveNpo] = useState(false);
  const [fixNPO, setFixNPO] = useState(false);
  const [cancellationPaymentModal, setCancellationPaymentModal] = useState(
    false
  );
  const [selectedCancellationData, setSelectedCancellationData] = useState({});
  const [feedbackCallOpen, setFeedbackCallOpen] = useState(false);
  const [paymentAccess, setPaymentAccess] = useState(false);
  const [rtoDocumentOpen, setRtoDocumentOpen] = useState(false);
  const [pymidolModalVisible, setPymidolModalVisible] = useState(false);
  const [pymidolActiveRecord, setPymidolActiveRecord] = useState(null);
  const [gatePassOtpOpen, setGatePassOtpOpen] = useState(false);
  const [selectedForGatePassOtp, setSelectedForGatePassOtp] = useState(null);

  const history = useHistory();

  useEffect(() => {
    if (type === "pending" && loginCredintials) {
      const branchPic =
        loginCredintials.branch?.[0]?.personInCharge?.map((pic) => pic.id) ||
        [];
      if (branchPic.length > 0 && loginCredintials.employeeId) {
        setAuthorization(branchPic.includes(loginCredintials.employeeId));
      } else {
        setAuthorization(false);
      }
    }
  }, [loginCredintials, type]);

  // Memoize updateSaleStatus
  const updateSaleStatus = useCallback(
    async (id, status) => {
      try {
        await platformApi.put(`/api/saleRegister/updateStatus/${id}`, {
          status,
        });
        refreshData();
      } catch (err) {
        console.error("Error updating booking status:", err);
        message.warning("Vehicle updated, but booking status update failed");
      }
    },
    [refreshData]
  );


  // Memoize openAuthModal
  const openAuthModal = useCallback(async (id, edit) => {
    try {
      const result = await platformApi.get(`/api/booking/${id}`);
      console.log("result", result);
      const { data } = result;
      if (data.code === 200) {
        const { response } = data;
        if (response.code === 200) {
          setBookingData(response.data);
          setOpenAuth(true);
          setEditable(edit === "edit");
        } else {
          message.error("Unable to fetch booking data", 2);
        }
      } else {
        message.error("Unable to fetch booking data", 2);
      }
    } catch (error) {
      console.error("Error fetching booking data:", error);
      message.error("Unable to fetch booking data", 2);
    }
  }, []);

  // Memoize payment view functions
  const openViewPayments = useCallback(async (id) => {
    try {
      const res = await platformApi.get(`/api/booking/${id}/payments`);
      const { data } = res;
      if (data.code === 200 && data.response.code === 200) {
        const payments = data.response.data.payments || [];
        const financePayments = data.response.data.financePayments || [];
        // Merge both regular and finance payments
        const allPayments = Array.isArray(payments) ? payments : [payments];
        const allFinancePayments = Array.isArray(financePayments) ? financePayments : [financePayments];

        setSelectedPayments([...allPayments, ...allFinancePayments]);
        setViewPaymentsOpen(true);
      } else {
        message.error("Unable to fetch payment details", 2);
      }
    } catch (error) {
      console.error(error);
      message.error("Error fetching payments", 2);
    }
  }, []);

  const openViewCancellationPayments = useCallback(async (id) => {
    try {
      const res = await platformApi.get(`/api/booking/${id}/payments`);
      const { data } = res;
      if (data.code === 200 && data.response.code === 200) {
        const payments = data.response.data.CancellationPayments || [];
        setSelectedPayments(Array.isArray(payments) ? payments : [payments]);
        setViewCancellationPaymentsOpen(true);
      } else {
        message.error("Unable to fetch payment details", 2);
      }
    } catch (error) {
      console.error(error);
      message.error("Error fetching payments", 2);
    }
  }, []);

  const openViewCompanyPayments = useCallback(async (id) => {
    try {
      const res = await platformApi.get(`/api/booking/${id}/payments`);
      const { data } = res;
      if (data.code === 200 && data.response.code === 200) {
        const payments = data.response.data.companyPayments || [];
        setselectedCompanyPayments(
          Array.isArray(payments) ? payments : [payments]
        );
        setViewCompanyPaymentsOpen(true);
      } else {
        message.error("Unable to fetch payment details", 2);
      }
    } catch (error) {
      console.error(error);
      message.error("Error fetching payments", 2);
    }
  }, []);

  // Memoize access check functions
  const isBranchIncharge = useMemo(() => {
    if (!loginCredintials || !loginCredintials.employeeId) return false;
    const empId = loginCredintials.employeeId;

    const branches = Array.isArray(loginCredintials.branch)
      ? loginCredintials.branch
      : loginCredintials.branch
      ? [loginCredintials.branch]
      : [];

    return branches.some((b) => {
      const pics = b.personInCharge || [];
      return pics.some((pic) => (typeof pic === "object" ? pic.id === empId : pic === empId));
    });
  }, [loginCredintials]);

  const hasCashCollectAccess = useMemo(() => {
    if (loginCredintials?.roleAccess) {
      return loginCredintials.roleAccess.some(
        (acc) =>
          acc.master === "TRANSACTIONMASTER" &&
          (acc.subModule === "Cash Payment" ||
            acc.subModule === "POS Machine") &&
          acc.access.create === true
      );
    }
    return false;
  }, [loginCredintials?.roleAccess]);

  // Role Access: TRANSACTIONMASTER → sale_booking_redo → create
  const canSaleBookingRedo = Boolean(
    loginCredintials?.roleAccess?.some(
      (each) => each.subModule === "sale_booking_redo" && each.access?.create
    )
  );


  useEffect(() => {
    setPaymentAccess(loginCredintials.roleAccess.some(
      (acc) =>
        acc.subModule === "Payment" &&
        acc.access.create === true
    ));
  }, [loginCredintials?.roleAccess])

  // Memoize booking action functions
  const rejectBooking = useCallback(
    (id) => {
      platformApi
        .put(`/api/dashboard/rejectBooking/${id}`)
        .then((res) => {
          const { data } = res;
          if (data.code === 200) {
            const { response } = data;
            if (response.code === 200) {
              message.success("Booking rejected successfully", 2);
              refreshData();
            } else {
              message.error("Unable to reject booking", 2);
            }
          } else {
            message.error("Unable to reject booking", 2);
          }
        })
        .catch((error) => {
          console.error("Error rejecting booking:", error);
          message.error("Unable to reject booking", 2);
        });
    },
    [refreshData]
  );

  const revertBooking = useCallback(
    (id, bookingStatus) => {
      platformApi
        .post(`/api/booking/revertBooking/${id}`, { bookingStatus })
        .then((res) => {
          const { data } = res;
          if (data.code === 200) {
            message.success("Booking Reverted successfully");
            refreshData();
          } else {
            message.error("Unable to revert booking");
          }
        })
        .catch((error) => {
          console.error("Error reverting booking:", error);
          message.error("Unable to revert booking");
        });
    },
    [refreshData]
  );

  const revertSaleInvoice = useCallback(
    (saleRegisterId) => {
      platformApi
        .post(`/api/saleRegister/revertInvoice/${saleRegisterId}`)
        .then((res) => {
          const { data } = res;
          if (data.code === 200) {
            message.success(data.message || "Invoice reverted. Moved to To Invoice.");
            refreshData();
          } else {
            message.error(data.message || "Unable to revert invoice");
          }
        })
        .catch((error) => {
          console.error("Error reverting invoice:", error);
          const msg =
            error?.response?.data?.message ||
            error?.message ||
            "Unable to revert invoice";
          message.error(msg);
        });
    },
    [refreshData]
  );

  const revertSaleRegister = useCallback(
    (saleRegisterId) => {
      platformApi
        .post(`/api/saleRegister/revertSale/${saleRegisterId}`)
        .then((res) => {
          const { data } = res;
          if (data.code === 200) {
            message.success(
              data.message || "Sale reverted. Moved to Authorized Bookings."
            );
            refreshData();
          } else {
            message.error(data.message || "Unable to revert sale");
          }
        })
        .catch((error) => {
          console.error("Error reverting sale:", error);
          const msg =
            error?.response?.data?.message ||
            error?.message ||
            "Unable to revert sale";
          message.error(msg);
        });
    },
    [refreshData]
  );

  const handleReasonChange = useCallback((id, value) => {
    setReasons((prev) => ({
      ...prev,
      [id]: value,
    }));
  }, []);

  // Memoize columns array - this is a major performance optimization
  const column = useMemo(
    () => [
      {
        title: "Booking ID",
        key: "bookingId",
        render: (record) =>
          isSales ? (
            <span>{record.saleId}</span>
          ) : (
            <span>{record.bookingId}</span>
          ),
      },
      {
        title: "Customer Name",
        dataIndex: "customer",
        key: "customerName",
        render: (record, data) => {
          const customerObj = record || (data?.customerId ? { id: data.customerId, name: data.customerName } : null);
          const nameStr = record?.name || data?.customerName || "-";
          return (
            <span
              className="linkylink"
              onClick={(e) => {
                e.stopPropagation();
                if (customerObj) {
                  setSelectedCustomer(customerObj);
                  setCustomerLedgerOpen(true);
                }
              }}
            >
              {nameStr}
            </span>
          );
        },
      },
      {
        title: "Vehicle",
        dataIndex: "vehicle",
        key: "model",
        width: 260,
        render: (record, row) => (
          <div style={{ display: "flex", alignItems: "center" }}>
            {row.selectedVehicle &&
              row.selectedVehicle[0] &&
              row.selectedVehicle[0].color &&
              row.selectedVehicle[0].color.url && (
                <img
                  src={row.selectedVehicle[0].color.url}
                  alt={record.modelName}
                  style={{
                    width: 50,
                    height: 50,
                    objectFit: "cover",
                    marginRight: 8,
                    borderRadius: 4,
                  }}
                />
              )}
            <VehicleName nameOnly value={record} modelName={record?.modelName} />
          </div>
        ),
      },

      {
        title: "Mode of Payment",
        dataIndex: "price",
        key: "paymentMode",
        render: (price, row) => (
          <span>
            {row && row.price && row.price.paymentMode && (
              <>
                {row.price.paymentMode.charAt(0).toUpperCase() +
                  row.price.paymentMode.slice(1)}
                {row.price.paymentMode.toLowerCase() === "finance" &&
                  row.loan &&
                  row.loan.financer && <> - {row.loan.financer.name}</>}
              </>
            )}
          </span>
        ),
      },
      {
        title: "Sales Executive",
        dataIndex: "executive",
        key: "executive",
        render: (record) =>
          record &&
          record.profile && <span>{record.profile.employeeName}</span>,
      },
      {
        title: "Branch",
        dataIndex: "branch",
        key: "branch",
        render: (record) => record && <span>{record.name}</span>,
      },
      ...(isSales
        ? []
        : [
          {
            title: "Expected Delivery Date",
            key: "expectedDeliveryDate",
            render: (_, row) => {
              if (row.expectedDeliveryDate) {
                return <span>{moment(row.expectedDeliveryDate).format("DD/MM/YYYY")}</span>;
              }
              const svDate =
                row.selectedVehicle &&
                row.selectedVehicle[0] &&
                row.selectedVehicle[0].expectedDeliveryDate;
              if (svDate) {
                return <span>{moment(svDate).format("DD/MM/YYYY")}</span>;
              }
              return <span>-</span>;
            },
          },
        ]),
      ...(type === "authorized" || type == "advanced" || type == "pending"
        ? [
          {
            title: "Total Amount (₹)",
            dataIndex: "price",
            key: "totalAmount",
            render: (price) => (
              <span>
                {price && price.finalAmount
                  ? Number(price.finalAmount).toLocaleString("en-IN")
                  : "-"}
              </span>
            ),
          },
          {
            title: "Received Amount (₹)",
            key: "receivedAmount",
            render: (_, record) => {
              const payments = Array.isArray(record.payment)
                ? record.payment
                : record.payment
                  ? [record.payment]
                  : [];
              const totalCollected = payments.reduce(
                (sum, p) =>
                  p.status === "SUCCESS"
                    ? sum + (Number(p.collectedAmount) || 0)
                    : sum,
                0
              );
              return <span>{totalCollected.toLocaleString("en-IN")}</span>;
            },
          },
        ]
        : []),
      {
        title: "Action",
        render: (record) => (
          <div style={{ display: "flex", alignItems: "center", flexWrap: "wrap", gap: "4px" }}>
            {isAuthorized &&
              (() => {
                const payments = Array.isArray(record.payment)
                  ? record.payment
                  : record.payment
                    ? [record.payment]
                    : [];
                const totalCollected = payments.reduce(
                  (sum, p) =>
                    p.status === "SUCCESS"
                      ? sum + (Number(p.collectedAmount) || 0)
                      : sum,
                  0
                );
                let billAmount = Number(record.price?.netRecieveables || 0);
                const isFinanceMode = record.price?.paymentMode?.toLowerCase() === "finance";
                if (billAmount === 0 && isFinanceMode) {
                  billAmount = Number(
                    record.price?.finalAmount ||
                    record.price?.onRoadPrice ||
                    record.vehicle?.price?.[0]?.showroomPrice ||
                    0
                  );
                }
                const isFullyPaid =
                  totalCollected >= billAmount && billAmount > 0;
                if (isFullyPaid && isBranchIncharge) {
                  return (
                    <span
                      onClick={(event) => {
                        event.stopPropagation();
                        openChassisModal(isSales ? (record.bookingUuid || record.id) : record.id, true);
                      }}
                      className="linkylink"
                    >
                      Allocate Chassis
                      <Divider type="vertical" />
                    </span>
                  );
                } else {
                  return null;
                }
              })()}
            {authorization && (
              <>
                <span
                  onClick={(event) => {
                    event.stopPropagation();
                    openAuthModal(isSales ? (record.bookingUuid || record.id) : record.id, "edit");
                  }}
                  className="linkylink"
                >
                  Authorize
                  <Divider type="vertical" />
                </span>
                <Popconfirm
                  title="Do you really want to reject this booking?"
                  okText="Yes"
                  cancelText="No"
                  onCancel={(event) => {
                    event.stopPropagation();
                  }}
                  onConfirm={(event) => {
                    event.stopPropagation();
                    rejectBooking(isSales ? (record.bookingUuid || record.id) : record.id);
                  }}
                >
                  <span
                    onClick={(event) => {
                      event.stopPropagation();
                    }}
                    className="linkylink"
                  >
                    Reject
                  </span>
                </Popconfirm>
              </>
            )}

            {
              advancedBookingModifyAccess ? (
                record.bookingStatus !== "REJECTED" && (
                  <>
                    <span
                      onClick={(event) => {
                        event.stopPropagation();
                        openModal(isSales ? (record.bookingUuid || record.id) : record.id, true);
                      }}
                      className="linkylink"
                    >
                      Modify
                    </span>
                    {advancedBookingModifyAccess && (
                      <span
                        onClick={(event) => {
                          event.stopPropagation();
                          openModal(isSales ? (record.bookingUuid || record.id) : record.id, true, true);
                        }}
                        className="linkylink"
                      >
                        <Divider type="vertical" />
                        Confirm
                      </span>
                    )}
                  </>
                )
              ) : (
                <span></span>
              )
            }

            {
              (tab == "invoiced" || tab == "INSURANCE" || tab == "NPO" || tab == "NPR" || tab == "NPF") && (
                <>
                  <span
                    onClick={(event) => {
                      event.stopPropagation();
                      if (record.saleInvoiceNo) {
                        const encodedInvoiceNo = encodeURIComponent(record.saleInvoiceNo);
                        window.open(`${ENDPOINT}api/saleInvoice/generate?invoiceNo=${encodedInvoiceNo}`, "_blank", "noopener,noreferrer");
                      } else if (record.pdf) {
                        window.open(record.pdf, "_blank", "noopener,noreferrer");
                      } else {
                        message.error("No invoice for this sale register found");
                      }
                    }}
                    className="linkylink"
                  >
                    View Invoice
                  </span>
                </>
              )
            }

            {
              tab == "toInvoice" && (
                <span
                  onClick={(event) => {
                    event.stopPropagation();
                    openInvoiceModal(record.salesId, false);
                  }}
                  className="linkylink"
                >
                  Add Invoice
                </span>
              )
            }

            {isSales && tab === "toInvoice" && canSaleBookingRedo && (
              <>
                <Divider type="vertical" />
                <Popconfirm
                  title={
                    <div style={{ maxWidth: 360 }}>
                      <div style={{ fontWeight: 600, marginBottom: 8 }}>
                        Revert this sale to Authorized Bookings?
                      </div>
                      <div style={{ marginBottom: 6 }}>This will:</div>
                      <ul style={{ margin: 0, paddingLeft: 18 }}>
                        <li>Put the chassis back into inventory</li>
                        <li>Delete the sold vehicle record</li>
                        <li>Delete the PDI job card</li>
                        <li>Remove this sale from Sales Register</li>
                        <li>Move the booking back to Authorized Bookings</li>
                      </ul>
                      <div style={{ marginTop: 8, color: "#a8071a" }}>
                        Note: If this vehicle was already pushed to Pymidol, that
                        external record cannot be un-pushed. Collected booking
                        payments will be kept.
                      </div>
                    </div>
                  }
                  okText="Yes, Revert"
                  cancelText="No"
                  onCancel={(event) => {
                    event.stopPropagation();
                  }}
                  onConfirm={(event) => {
                    event.stopPropagation();
                    revertSaleRegister(record.salesId || record.id);
                  }}
                >
                  <span
                    className="linkylink"
                    onClick={(event) => {
                      event.stopPropagation();
                    }}
                  >
                    Revert
                  </span>
                </Popconfirm>
              </>
            )}

            {isSales && tab === "invoiced" && canSaleBookingRedo && (
              <>
                <Divider type="vertical" />
                <Popconfirm
                  title={(() => {
                    const financeCollected = Array.isArray(record.financePayments)
                      ? record.financePayments.reduce(
                          (sum, p) => sum + (parseFloat(p.collectedAmount) || 0),
                          0
                        )
                      : 0;
                    const exchangeCollected = Array.isArray(record.exchangePayments)
                      ? record.exchangePayments.reduce(
                          (sum, p) => sum + (parseFloat(p.collectedAmount) || 0),
                          0
                        )
                      : 0;
                    if (financeCollected > 0 || exchangeCollected > 0) {
                      return `Financer/Exchange dues already collected (₹${(
                        financeCollected + exchangeCollected
                      ).toLocaleString("en-IN")}) will be kept. Revert invoice to To Invoice?`;
                    }
                    return "Do you really want to revert this invoice? Record will move to To Invoice.";
                  })()}
                  okText="Yes"
                  cancelText="No"
                  onCancel={(event) => {
                    event.stopPropagation();
                  }}
                  onConfirm={(event) => {
                    event.stopPropagation();
                    revertSaleInvoice(record.salesId || record.id);
                  }}
                >
                  <span
                    className="linkylink"
                    onClick={(event) => {
                      event.stopPropagation();
                    }}
                  >
                    Revert
                  </span>
                </Popconfirm>
              </>
            )}

            {isSales && invoiceStatus && (
              <>
                {(tab === "toInvoice" || tab === "invoiced" || tab === "INSURANCE") && (
                  <Divider type="vertical" />
                )}
                <span
                  className="linkylink"
                  onClick={(event) => {
                    event.stopPropagation();
                    console.log("DEBUG: Upload Photo Clicked. Record Data:", record);
                    setData(record);
                    setGatepassOpen(true);
                  }}
                >
                  Upload Photo
                </span>
                {/* <Divider type="vertical" />
                <span
                  className="linkylink"
                  onClick={(event) => {
                    event.stopPropagation();
                    setData(record);
                    setInsuranceOpen(true);
                  }}
                >
                  Add Insurance
                </span> */}
              </>
            )}

            {
              tab === "RFR" && (
                <>
                  <Divider type="vertical" />
                  <span
                    onClick={(event) => {
                      event.stopPropagation();
                    }}
                    className="linkylink"
                  >
                    Push To RTO
                  </span>
                  <Divider type="vertical" />
                  <span
                    onClick={(event) => {
                      event.stopPropagation();
                      setPymidolActiveRecord(record);
                      setPymidolModalVisible(true);
                    }}
                    className="linkylink"
                  >
                    Push to Pymidol
                  </span>
                  <Divider type="vertical" />
                  <span
                    onClick={(event) => {
                      event.stopPropagation();
                      setData(record);
                      setNumberPlateModal(true);
                    }}
                    className="linkylink"
                  >
                    Add E-Receipt
                  </span>
                  <Divider type="vertical" />
                  <span
                    onClick={(event) => {
                      event.stopPropagation();
                      setSelectedForGatePassOtp(record);
                      setGatePassOtpOpen(true);
                    }}
                    className="linkylink"
                  >
                    Generate Gate Pass OTP
                  </span>
                </>
              )
            }

            {
              (tab === "invoiced" || tab === "INSURANCE") &&
              record.price?.paymentMode?.toLowerCase() === "finance" &&
              (record.loan?.loanType || record.saleData?.loan?.loanType)?.toLowerCase() !== "self" && (
                <>
                  <Divider type="vertical" />
                  {record.financePayments &&
                    record.financePayments.length > 0 &&
                    record.financePayments.reduce(
                      (sum, p) => sum + (parseFloat(p.collectedAmount) || 0),
                      0
                    ) >= (record.loan?.disbursementAmount || record.saleData?.loan?.disbursementAmount || 0) ? (
                    <Button
                      type="primary"
                      icon={<CheckCircleOutlined />}
                      size="small"
                      disabled
                      style={{
                        backgroundColor: "#e0c3e3",
                        borderColor: "#1e0221",
                        color: "black",
                        cursor: "not-allowed",
                        opacity: 1,
                      }}
                    >
                      Finance Due Completed
                    </Button>
                  ) : (
                    <span
                      onClick={(event) => {
                        event.stopPropagation();
                        setFinancerData(isSales ? { ...record, id: record.bookingUuid || record.id } : record);
                        setFinancerModalOpen(true);
                      }}
                      className="linkylink"
                    >
                      Financer Due
                    </span>
                  )}
                </>
              )
            }

            {
              (tab === "invoiced" || tab === "INSURANCE") &&
              parseFloat(record.exchange?.vehiclePrice || 0) > 0 && (
                <>
                  <Divider type="vertical" />
                  {record.exchangePayments &&
                    record.exchangePayments.length > 0 &&
                    record.exchangePayments.reduce(
                      (sum, p) => sum + (parseFloat(p.collectedAmount) || 0),
                      0
                    ) >= parseFloat(record.exchange?.vehiclePrice || 0) ? (
                    <Button
                      type="primary"
                      icon={<CheckCircleOutlined />}
                      size="small"
                      disabled
                      style={{
                        backgroundColor: "#e0c3e3",
                        borderColor: "#1e0221",
                        color: "black",
                        cursor: "not-allowed",
                        opacity: 1,
                      }}
                    >
                      Exchange Due Completed
                    </Button>
                  ) : (
                    <span
                      onClick={(event) => {
                        event.stopPropagation();
                        setExchangeData(isSales ? { ...record, id: record.bookingUuid || record.id } : record);
                        setExchangeModalOpen(true);
                      }}
                      className="linkylink"
                    >
                      Exchange Due
                    </span>
                  )}
                </>
              )
            }

            {
              tab == "NPR" && (
                <>
                  <Divider type="vertical" />
                  <span
                    onClick={(event) => {
                      event.stopPropagation();
                      setData(record);
                      setFixNPO(true);
                    }}
                    className="linkylink"
                  >
                    Fix Number Plate
                  </span>
                </>
              )
            }

            {
              tab == "NPF" && (
                <>
                  <Divider type="vertical" />
                  <span
                    onClick={(event) => {
                      event.stopPropagation();
                      // setData({...record, view:false, booking:true})
                      // setFeedbackCallOpen(true);
                      let phone = record.customerPhone || record.customer?.contacts?.[0]?.phone;
                      if (phone) {
                        history.push({
                          pathname: `/autoadmin/sales_feedback_call/${phone}`,
                          state: {
                            status: "NPF"
                          },
                        });
                      } else {
                        message.error("Phone number not found");
                      }
                    }}
                    className="linkylink"
                  >
                    Feedback Call
                  </span>
                </>
              )
            }

            {
              (tab == "COMPLETED") && record.customerFeedback && (
                <>
                  {/* <Divider type="vertical" /> */}
                  <span
                    onClick={(event) => {
                      event.stopPropagation();
                      setData({ ...record, view: true })
                      setFeedbackCallOpen(true);
                    }}
                    className="linkylink"
                  >
                    Customer Feedback
                  </span>
                </>
              )
            }

            {
              type === "cancelled" && record.cancellationPayments?.length > 0 && (
                <>
                  <span
                    onClick={(event) => {
                      event.stopPropagation();
                      setData(isSales ? { ...record, id: record.bookingUuid || record.id } : record);
                      openViewCancellationPayments(isSales ? (record.bookingUuid || record.id) : record.id);
                    }}
                    className="linkylink"
                  >
                    Cancellation Transactions
                  </span>
                </>
              )
            }

            {
              type === "cancelled" &&
              record.cancellationAmount && record.bookingStatus !== "REJECTED_REFUNDED" &&

              <>
                <Divider type="vertical" />
                <span
                  className="linkylink"
                  onClick={(event) => {
                    event.stopPropagation();
                    setSelectedCancellationData(record);
                    setCancellationPaymentModal(true);
                  }}
                >
                  Make Cancellation Payment
                </span>
              </>
            }
            {
              deleteAccess ? (
                advancedBookingModifyAccess ? (
                  <div>
                    <Divider type="vertical" />
                    <Popconfirm
                      title={
                        <div style={{ maxWidth: 260 }}>
                          <div>Do you want to cancel this Booking?</div>
                          <div style={{ marginTop: 10 }}>
                            <Input.TextArea
                              placeholder="Reason for cancellation"
                              rows={3}
                              onClick={(e) => e.stopPropagation()}
                              onChange={(e) => {
                                const value = e.target.value;
                                // Allow only alphanumeric and spaces
                                const sanitizedValue = value.replace(/[^a-zA-Z0-9\s]/g, "");
                                handleReasonChange(record.id, {
                                  ...reasons[record.id],
                                  reason: sanitizedValue,
                                });
                              }}
                              value={reasons[record.id]?.reason || ""}
                            />
                          </div>
                          <br />

                          <label
                            style={{
                              fontWeight: "500",
                              marginBottom: 4,
                              display: "block",
                            }}
                          >
                            Cancellation Amount
                          </label>

                          <div style={{ marginTop: 10 }}>
                            <Input
                              placeholder="Cancellation Amount"
                              type="number"
                              min={0}
                              onClick={(e) => e.stopPropagation()}
                              onKeyDown={(e) => {
                                if (["-", "e", "+"].includes(e.key)) {
                                  e.preventDefault();
                                }
                              }}
                              onWheel={(e) => e.target.blur()}
                              onChange={(e) =>
                                handleReasonChange(record.id, {
                                  ...reasons[record.id],
                                  cancelAmount: e.target.value,
                                })
                              }
                              value={reasons[record.id]?.cancelAmount || ""}
                            />
                          </div>
                        </div>
                      }
                      okText="Yes"
                      cancelText="No"
                      onCancel={(event) => {
                        event.stopPropagation();
                        setReasons({});
                      }}
                      onConfirm={(event) => {
                        event.stopPropagation();

                        const reasonObj = reasons[record.id] || {};
                        const { reason, cancelAmount } = reasonObj;

                        if (parseFloat(cancelAmount) < 0) {
                          message.error("Cancellation Amount cannot be negative");
                          return;
                        }

                        updateDataStatus(reason, record.id, cancelAmount);

                        setReasons({});
                      }}
                    >
                      <span
                        onClick={(event) => {
                          event.stopPropagation();
                        }}
                        className="linkylink"
                      >
                        Cancel
                      </span>
                    </Popconfirm>
                  </div>
                ) : null
              ) : (
                <span></span>
              )
            }

            {
              paymentAccess && (
                <>
                  <Divider type="vertical" />
                  <span
                    onClick={(event) => {
                      event.stopPropagation();
                      setData(isSales ? { ...record, id: record.bookingUuid || record.id } : record);
                      setPaymentModal(true);
                    }}
                    className="linkylink"
                  >
                    Payment
                  </span>
                  <Divider type="vertical" />
                  <span
                    onClick={(event) => {
                      event.stopPropagation();
                      setData(isSales ? { ...record, id: record.bookingUuid || record.id } : record);
                      openViewCompanyPayments(isSales ? (record.bookingUuid || record.id) : record.id);
                    }}
                    className="linkylink"
                  >
                    ViewPayments
                  </span>
                </>
              )
            }

            {
              tab === "INSURANCE" && (
                (() => {
                  const isSelfLoan = (record.loan?.loanType || record.saleData?.loan?.loanType)?.toLowerCase() === "self";
                  const hasFinance = record.price?.paymentMode?.toLowerCase() === "finance" && !isSelfLoan;
                  const financeCompleted = !hasFinance || (
                    record.financePayments &&
                    record.financePayments.length > 0 &&
                    record.financePayments.reduce((sum, p) => sum + (parseFloat(p.collectedAmount) || 0), 0) >= (record.loan?.disbursementAmount || record.saleData?.loan?.disbursementAmount || 0)
                  );

                  const hasExchange = parseFloat(record.exchange?.vehiclePrice || 0) > 0;
                  const exchangeCompleted = !hasExchange || (
                    record.exchangePayments &&
                    record.exchangePayments.length > 0 &&
                    record.exchangePayments.reduce((sum, p) => sum + (parseFloat(p.collectedAmount) || 0), 0) >= parseFloat(record.exchange?.vehiclePrice || 0)
                  );

                  if (financeCompleted && exchangeCompleted) {
                    return (
                      <>
                        <Divider type="vertical" />
                        <span
                          onClick={(event) => {
                            event.stopPropagation();
                            setData(isSales ? { ...record, id: record.bookingUuid || record.id } : record);
                            setNumberPlateModal(true);
                          }}
                          className="linkylink"
                        >
                          Add E-Receipt
                        </span>
                      </>
                    );
                  }
                  return null;
                })()
              )
            }

            {
              tab == "NPO" && (
                <>
                  <Divider type="vertical" />
                  <span
                    onClick={(event) => {
                      event.stopPropagation();
                      setData(record);
                      setReceiveNpo(true);
                    }}
                    className="linkylink"
                  >
                    Receive Number Plate
                  </span>
                </>
              )
            }



            {
              (tab == "INSURANCE" || tab == "RFR") ? (
                <>
                  <Divider type="vertical" />
                  <a
                    href={`${baseUrl}api/saleregister/form14/${record.salesId}`}
                    style={{ color: "#636363", textDecoration: "none" }}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="linkylink"
                    onClick={(event) => {
                      console.log('Form14 clicked - salesId:', record.salesId);
                      console.log('Form14 URL:', `${baseUrl}api/saleregister/form14/${record.salesId}`);
                      event.stopPropagation();
                      if (onForm14Download && typeof onForm14Download === 'function') {
                        event.preventDefault();
                        onForm14Download(record.salesId, event);
                      }
                    }}
                  >
                    <span className="linkylink">Form14</span>
                  </a>
                  {(tab === "INSURANCE" || tab === "RFR") && (
                    <>
                      <Divider type="vertical" />
                      <a
                        href={`${baseUrl}api/saleregister/form19/${record.salesId}`}
                        style={{ color: "#636363", textDecoration: "none" }}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="linkylink"
                        onClick={(event) => {
                          console.log('Form19 clicked - salesId:', record.salesId);
                          event.stopPropagation();
                          if (onForm19Download && typeof onForm19Download === 'function') {
                            event.preventDefault();
                            onForm19Download(record.salesId, event);
                          }
                        }}
                      >
                        <span className="linkylink">Form19</span>
                      </a>
                    </>
                  )}
                </>
              ) : null
            }

            {
              (type === "authorized" ||
                type === "pending" ||
                type === "advanced" || type === "sold") && (
                <>
                  <Divider type="vertical" />
                  <span
                    onClick={(event) => {
                      event.stopPropagation();
                      setData(isSales ? { ...record, id: record.bookingUuid || record.id } : record);
                      openViewPayments(isSales ? (record.bookingUuid || record.id) : record.id);
                    }}
                    className="linkylink"
                  >
                    Receipts
                  </span>
                </>
              )
            }

            {
              printAccess &&
              <>
                <Divider type="vertical" />
                <a
                  href={`${baseUrl}api/saleregister/printPDF/${record.salesId}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="linkylink"
                  onClick={(event) => event.stopPropagation()}
                >
                  Print
                </a>
              </>
            }
            {
              (modify || authorization || record.bookingStatus == "REJECTED" || record.bookingStatus == "REJECTED_REFUNDED") &&
                record.bookingStatus != "ALL" &&
                record.bookingStatus != "SOLD" &&
                record.bookingStatus != "ADVANCE" ? (
                <>
                  <Divider type="vertical" />
                  <Popconfirm
                    title="Do you really want to revert this booking?"
                    okText="Yes"
                    cancelText="No"
                    onCancel={(event) => {
                      event.stopPropagation();
                    }}
                    onConfirm={(event) => {
                      event.stopPropagation();
                      revertBooking(isSales ? (record.bookingUuid || record.id) : record.id, record.bookingStatus);
                    }}
                  >
                    <span
                      className="linkylink"
                      onClick={(event) => {
                        event.stopPropagation();
                      }}
                    >
                      Revert
                    </span>
                  </Popconfirm>
                </>
              ) : null
            }

            {
              hasCashCollectAccess &&
              (type === "authorized" ||
                type === "advanced" ||
                type === "pending") && (
                <>
                  <Divider type="vertical" />
                  {(() => {
                    const payments = Array.isArray(record.payment)
                      ? record.payment
                      : record.payment
                        ? [record.payment]
                        : [];
                    const totalCollected = payments.reduce(
                      (sum, p) =>
                        p.status === "SUCCESS"
                          ? sum + (Number(p.collectedAmount) || 0)
                          : sum,
                      0
                    );
                    let billAmount = Number(record.price?.netRecieveables || 0);
                    const isFinanceMode = record.price?.paymentMode?.toLowerCase() === "finance";
                    if (billAmount === 0 && isFinanceMode) {
                      billAmount = Number(
                        record.price?.finalAmount ||
                        record.price?.onRoadPrice ||
                        record.vehicle?.price?.[0]?.showroomPrice ||
                        0
                      );
                    }
                    const remainingAmount = billAmount - totalCollected;
                    const isFullyPaid = billAmount > 0 && totalCollected >= billAmount;
                    const isPartiallyPaid =
                      totalCollected > 0 && !isFullyPaid;

                    if (isFullyPaid) {
                      return (
                        <Button
                          type="primary"
                          icon={<CheckCircleOutlined />}
                          size="small"
                          disabled
                          style={{
                            backgroundColor: "#e0c3e3",
                            borderColor: "#1e0221",
                            color: "black",
                            cursor: "not-allowed",
                            opacity: 1,
                          }}
                        >
                          Payment Completed
                        </Button>
                      );
                    } else {
                      return (
                        <Button
                          type="primary"
                          icon={<CreditCardOutlined />}
                          size="small"
                          onClick={(event) => {
                            event.stopPropagation();
                            openPaymentModal(record);
                          }}
                        >
                          {totalCollected === 0
                            ? "Collect Cash"
                            : `Collect Cash Remaining ₹${remainingAmount.toLocaleString("en-IN")}`}
                        </Button>
                      );
                    }
                  })()}
                </>
              )
            }

            {
              !modify &&
                !deleteAccess &&
                !isSales &&
                !authorization &&
                record.bookingStatus != "REJECTED" && record.bookingStatus != "REJECTED_REFUNDED" ? (
                <Text strong disabled>
                  No Actions Given
                </Text>
              ) : (
                <span></span>
              )
            }
          </div >
        ),
      },
    ],
    [
      isSales,
      type,
      isAuthorized,
      authorization,
      modify,
      advancedBookingModifyAccess,
      invoiceStatus,
      mainData,
      tab,
      deleteAccess,
      paymentAccess,
      hasCashCollectAccess,
      reasons,
      openChassisModal,
      openAuthModal,
      rejectBooking,
      openModal,
      openInvoiceModal,
      setData,
      setGatepassOpen,
      setInsuranceOpen,
      setFinancerData,
      setFinancerModalOpen,
      openViewPayments,
      openViewCancellationPayments,
      setPaymentModal,
      openViewCompanyPayments,
      setNumberPlateModal,
      setReceiveNpo,
      setFixNPO,
      setSelectedCancellationData,
      setCancellationPaymentModal,
      updateDataStatus,
      handleReasonChange,
      revertBooking,
      revertSaleInvoice,
      revertSaleRegister,
      canSaleBookingRedo,
      openPaymentModal,
      printAccess,
      exchangeModalOpen,
      setExchangeModalOpen,
      setExchangeData,
      onForm14Download,
      onForm19Download,
    ]
  );

  // Memoize card click (same as former Table onRow)
  const handleCardClick = useCallback(
    (record) => {
      openModal(isSales ? record.salesId : record.id, false);
    },
    [openModal, isSales]
  );

  const getColumnValue = useCallback((record, dataIndex) => {
    if (dataIndex == null) return record;
    if (Array.isArray(dataIndex)) {
      return dataIndex.reduce(
        (obj, key) => (obj == null ? obj : obj[key]),
        record
      );
    }
    return record[dataIndex];
  }, []);

  const dataColumns = useMemo(
    () =>
      column.filter(
        (col) => col.title !== "Action" && col.key !== "model"
      ),
    [column]
  );
  const actionColumn = useMemo(
    () => column.find((col) => col.title === "Action"),
    [column]
  );

  const renderVehicleBlock = useCallback((record) => {
    const vehicle = record.vehicle;
    const colorUrl =
      record.selectedVehicle?.[0]?.color?.url || null;
    return (
      <div className="register-record-card__vehicle">
        <div className="register-record-card__vehicle-img">
          {colorUrl ? (
            <img src={colorUrl} alt={vehicle?.modelName || "vehicle"} />
          ) : (
            <div className="register-record-card__vehicle-placeholder" />
          )}
        </div>
        <div className="register-record-card__vehicle-name">
          <VehicleName nameOnly value={vehicle} />
        </div>
      </div>
    );
  }, []);

  const spinning = Boolean(
    spinner && (typeof spinner === "object" ? spinner.spinning : spinner)
  );

  return (
    <div className="register-record-list">
      <Spin spinning={spinning}>
        {!dataSource || dataSource.length === 0 ? (
          <Empty description="No records" style={{ margin: "40px 0" }} />
        ) : (
          <div className="register-record-cards">
            {dataSource.map((record, index) => (
              <div
                key={record.id}
                className={`register-record-card${
                  index % 2 === 1 ? " register-record-card--alt" : ""
                }`}
                onClick={() => handleCardClick(record)}
                role="button"
                tabIndex={0}
                onKeyDown={(e) => {
                  if (e.target !== e.currentTarget) return;
                  if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    handleCardClick(record);
                  }
                }}
              >
                <div className="register-record-card__main">
                  {renderVehicleBlock(record)}

                  <div className="register-record-card__details">
                    {dataColumns.map((col) => (
                      <div
                        key={col.key || col.title}
                        className={`register-record-card__field register-record-card__field--${
                          col.key || "meta"
                        }`}
                      >
                        <span className="register-record-card__label">
                          {col.title}
                        </span>
                        <div className="register-record-card__value">
                          {col.render
                            ? col.render(
                                getColumnValue(record, col.dataIndex),
                                record,
                                index
                              )
                            : getColumnValue(record, col.dataIndex)}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>

                {actionColumn && (
                  <div
                    className="register-record-card__actions"
                    onClick={(e) => e.stopPropagation()}
                    onKeyDown={(e) => e.stopPropagation()}
                  >
                    <div className="register-record-card__actions-inner">
                      {actionColumn.render(record, record, index)}
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>
        )}
      </Spin>

      {pagination && pagination.total > 0 && (
        <div className="register-record-pagination">
          <Pagination
            current={pagination.current}
            pageSize={pagination.pageSize}
            total={pagination.total}
            onChange={pagination.onChange}
            showQuickJumper={pagination.showQuickJumper}
            showSizeChanger={false}
          />
        </div>
      )}

      {cancellationPaymentModal && (
        <PaymentModal
          open={cancellationPaymentModal}
          close={() => {
            setCancellationPaymentModal(false);
            setSelectedCancellationData({});
          }}
          refreshData={refreshData}
          bookingId={selectedCancellationData.id}
          module="CANCELLATION_PAYMENT"
        />
      )}

      {openAuth && (
        <WrappedAuthenticationData
          open={openAuth}
          close={() => setOpenAuth(false)}
          id={bookingData.id}
          data={bookingData}
          editable={editable}
          reload={() => refreshData()}
        />
      )}

      {gatepassOpen && (
        <GatepassModal
          open={gatepassOpen}
          close={() => {
            setGatepassOpen(false);
          }}
          data={data}
        />
      )}

      {gatePassOtpOpen && selectedForGatePassOtp && (
        <GatePassOtpModal
          open={gatePassOtpOpen}
          onCancel={() => {
            setGatePassOtpOpen(false);
            setSelectedForGatePassOtp(null);
          }}
          mode="sales"
          jobOrder={{
            id: selectedForGatePassOtp.salesId || selectedForGatePassOtp.id,
            saleId: selectedForGatePassOtp.saleId || selectedForGatePassOtp.bookingId,
            bookingId: selectedForGatePassOtp.bookingId,
            chassisNumber:
              selectedForGatePassOtp.chassisNumber ||
              selectedForGatePassOtp.selectedVehicle?.[0]?.chassisNo ||
              selectedForGatePassOtp.vehicle?.chassisNo,
            customerPhone:
              selectedForGatePassOtp.customerPhone ||
              selectedForGatePassOtp.customer?.contacts?.[0]?.phone ||
              selectedForGatePassOtp.customer?.CustomerPhone?.[0]?.phone,
            customer: selectedForGatePassOtp.customer,
            vehicle: selectedForGatePassOtp.vehicle || {
              chassisNo:
                selectedForGatePassOtp.chassisNumber ||
                selectedForGatePassOtp.selectedVehicle?.[0]?.chassisNo,
            },
          }}
        />
      )}
      {financerModalOpen && (
        <FinancerModal
          open={financerModalOpen}
          close={() => {
            console.log("Parent: setFinancerModalOpen(false) called");
            setFinancerModalOpen(false);
          }}
          data={financerData}
          booking={bookingData}
          onPaymentSuccess={() => {
            console.log("Parent: onPaymentSuccess triggered");
            refreshData();
          }}
        />
      )}
      {exchangeModalOpen && (
        <ExchangeModal
          open={exchangeModalOpen}
          close={() => {
            setExchangeModalOpen(false);
          }}
          data={exchangeData}
          onPaymentSuccess={() => {
            refreshData();
          }}
        />
      )}

      {insuranceOpen && (
        <InsuranceModal
          open={insuranceOpen}
          close={() => {
            setInsuranceOpen(false);
            refreshData();
          }}
          vehicleId={data?.vehicleId}
          insurance={data?.insurance}
          bookingId={data?.salesId}
        />
      )}

      {numberPlateModal && (
        <AddNumberPlating
          open={numberPlateModal}
          close={() => {
            setNumberPlateModal(false);
          }}
          isMultiple={false}
          reloadData={() => updateSaleStatus(data?.salesId, "NPO")}
        />
      )}

      {receiveNPO && (
        <ChangeOrderStatusReceived
          open={receiveNPO}
          close={() => setReceiveNpo(false)}
          chassis={data.chassisNumber}
          reloadData={() => updateSaleStatus(data?.salesId, "NPR")}
        />
      )}

      {fixNPO && (
        <ChangeOrderStatusFixed
          open={fixNPO}
          close={() => setFixNPO(false)}
          chassis={data.chassisNumber}
          reloadData={() => updateSaleStatus(data?.salesId, "NPF")}
        />
      )}

      {paymentModal && (
        <PaymentModal
          open={paymentModal}
          close={() => {
            setPaymentModal(false);
          }}
          refreshData={refreshData}
          bookingId={data.id}
          module="PAYMENT"
        />
      )}

      {viewPaymentsOpen && (
        <Modal
          title="Payment Details"
          visible={viewPaymentsOpen}
          onCancel={() => setViewPaymentsOpen(false)}
          footer={null}
          width={1050}
          destroyOnClose
        >
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              marginBottom: 12,
            }}
          >
            <Button
              type="primary"
              icon={<DownloadOutlined />}
              href={`${ENDPOINT}api/payment/booking_register/receipt/${data.id}?group=true`}
              target="_blank"
              rel="noopener noreferrer"
            >
              Download All Receipts
            </Button>
          </div>
          <Table
            dataSource={[...(selectedPayments || [])].sort((a, b) => {
              const dateA = new Date(a.dateOfPayment || a.createdAt || 0).getTime();
              const dateB = new Date(b.dateOfPayment || b.createdAt || 0).getTime();
              return dateA - dateB;
            })}
            rowKey={(record) => record.id}
            pagination={false}
            scroll={{ x: "max-content" }}
            columns={[
              {
                title: <span style={{ whiteSpace: "nowrap" }}>S.No</span>,
                key: "serial",
                width: 70,
                align: "center",
                render: (text, record, index) => index + 1,
              },
              {
                title: <span style={{ whiteSpace: "nowrap" }}>Method</span>,
                dataIndex: "method",
                key: "method",
                width: 130,
                render: (method, record) => {
                  const val = record.module === "FINANCER_DUE" ? "FINANCE DUE" : (method ? method.toUpperCase() : "-");
                  return <span style={{ whiteSpace: "nowrap" }}>{val}</span>;
                },
              },
              {
                title: <span style={{ whiteSpace: "nowrap" }}>Collected Amount (₹)</span>,
                dataIndex: "collectedAmount",
                key: "collectedAmount",
                width: 150,
                render: (amt) => (
                  <span style={{ whiteSpace: "nowrap" }}>
                    {amt ? Number(amt).toLocaleString("en-IN") : "0"}
                  </span>
                ),
              },
              {
                title: <span style={{ whiteSpace: "nowrap" }}>Status</span>,
                dataIndex: "status",
                key: "status",
                width: 90,
                render: (status) => (
                  <span
                    style={{
                      color: status === "SUCCESS" ? "green" : "red",
                      fontWeight: 500,
                      whiteSpace: "nowrap",
                    }}
                  >
                    {status}
                  </span>
                ),
              },
              {
                title: <span style={{ whiteSpace: "nowrap" }}>Date</span>,
                key: "createdAt",
                width: 160,
                render: (record) => {
                  const date = record.dateOfPayment || record.createdAt;
                  const dateStr = date ? moment(date).format("DD/MM/YYYY, h:mm A") : "-";
                  return <span style={{ whiteSpace: "nowrap" }}>{dateStr}</span>;
                },
              },
              {
                title: <span style={{ whiteSpace: "nowrap" }}>Collected By</span>,
                key: "collectedBy",
                width: 160,
                render: (record) => {
                  const empName =
                    record.collectedBy?.employeeName ||
                    record.EmployeeProfile?.employeeName ||
                    record.employee?.profile?.employeeName ||
                    record.employee?.employeeName ||
                    (typeof record.collectedBy === "string" ? record.collectedBy : null);
                  if (!empName) return "-";
                  const formatted = empName
                    .toLowerCase()
                    .split(" ")
                    .map((word) => (word ? word.charAt(0).toUpperCase() + word.slice(1) : ""))
                    .join(" ");
                  return <span style={{ whiteSpace: "nowrap" }}>{formatted}</span>;
                },
              },
              {
                title: <span style={{ whiteSpace: "nowrap" }}>Account</span>,
                dataIndex: "bank",
                key: "bankName",
                width: 140,
                render: (bank, record) => {
                  let val = "-";
                  if (record.module === "FINANCER_DUE") {
                    const financierName = record.supplier?.name || record.branch?.name;
                    val = financierName ? financierName.toUpperCase() : "-";
                  } else if (bank) {
                    val = bank.accountNumber || "-";
                  }
                  return <span style={{ whiteSpace: "nowrap" }}>{val}</span>;
                },
              },
              {
                title: "",
                key: "download",
                align: "center",
                width: 50,
                render: (record) => {
                  const isDisabled = record.status !== "SUCCESS";

                  return (
                    <a
                      href={!isDisabled ? `${ENDPOINT}api/payment/booking_register/receipt/${record.id}?group=false` : '#'}
                      target={!isDisabled ? "_blank" : "_self"}
                      rel="noopener noreferrer"
                      title={isDisabled ? "Receipt not available for pending payments" : "Download Payment PDF"}
                      onClick={(e) => {
                        if (isDisabled) {
                          e.preventDefault();
                          message.info("Receipt will be available once payment is successful");
                        }
                      }}
                      style={{
                        pointerEvents: isDisabled ? "none" : "auto",
                        opacity: isDisabled ? 0.5 : 1,
                        cursor: isDisabled ? "not-allowed" : "pointer",
                        color: isDisabled ? "#ccc" : "#1890ff",
                        display: "inline-block"
                      }}
                    >
                      <DownloadOutlined style={{ fontSize: 18 }} />
                    </a>
                  );
                }
              }
            ]}
          />
        </Modal>
      )}
      {viewCancellationPaymentsOpen && (
        <Modal
          title="Cancellation Payment Details"
          visible={viewCancellationPaymentsOpen}
          onCancel={() => setViewCancellationPaymentsOpen(false)}
          footer={null}
          width={1050}
          destroyOnClose
        >
          <Table
            dataSource={[...(selectedPayments || [])].sort((a, b) => {
              const dateA = new Date(a.dateOfPayment || a.createdAt || 0).getTime();
              const dateB = new Date(b.dateOfPayment || b.createdAt || 0).getTime();
              return dateA - dateB;
            })}
            rowKey={(record) => record.id}
            pagination={false}
            scroll={{ x: "max-content" }}
            columns={[
              {
                title: <span style={{ whiteSpace: "nowrap" }}>S.No</span>,
                key: "serial",
                width: 70,
                align: "center",
                render: (text, record, index) => index + 1,
              },
              {
                title: <span style={{ whiteSpace: "nowrap" }}>Payment Mode</span>,
                dataIndex: "paymentMode",
                key: "method",
                width: 140,
                render: (method) => <span style={{ whiteSpace: "nowrap" }}>{method ? method.toUpperCase() : "-"}</span>,
              },
              {
                title: <span style={{ whiteSpace: "nowrap" }}>Collected Amount (₹)</span>,
                dataIndex: "collectedAmount",
                key: "collectedAmount",
                width: 160,
                render: (amt) => (
                  <span style={{ whiteSpace: "nowrap" }}>
                    {amt ? Number(amt).toLocaleString("en-IN") : "0"}
                  </span>
                ),
              },

              {
                title: <span style={{ whiteSpace: "nowrap" }}>Status</span>,
                dataIndex: "status",
                key: "status",
                width: 90,
                render: (status) => (
                  <span
                    style={{
                      color: status === "SUCCESS" ? "green" : "red",
                      fontWeight: 500,
                      whiteSpace: "nowrap",
                    }}
                  >
                    {status}
                  </span>
                ),
              },
              {
                title: <span style={{ whiteSpace: "nowrap" }}>Date</span>,
                key: "paymentDate",
                width: 160,
                render: (_, record) => {
                  const dateVal = record.dateOfPayment || record.createdAt;
                  const dateStr = dateVal ? moment(dateVal).format("DD/MM/YYYY, h:mm A") : "-";
                  return <span style={{ whiteSpace: "nowrap" }}>{dateStr}</span>;
                },
              },
              {
                title: <span style={{ whiteSpace: "nowrap" }}>Collected By</span>,
                key: "collectedBy",
                width: 160,
                render: (_, record) => {
                  const empName =
                    record.collectedBy?.employeeName ||
                    record.EmployeeProfile?.employeeName ||
                    record.employee?.profile?.employeeName ||
                    record.employee?.employeeName ||
                    (typeof record.collectedBy === "string" ? record.collectedBy : null);
                  if (!empName) return "-";
                  const formatted = empName
                    .toLowerCase()
                    .split(" ")
                    .map((word) => (word ? word.charAt(0).toUpperCase() + word.slice(1) : ""))
                    .join(" ");
                  return <span style={{ whiteSpace: "nowrap" }}>{formatted}</span>;
                },
              },
            ]}
          />
        </Modal>
      )}

      {viewCompanyPaymentsOpen && (
        <Modal
          title="Payment Details"
          visible={viewCompanyPaymentsOpen}
          onCancel={() => setViewCompanyPaymentsOpen(false)}
          footer={null}
          width={1050}
          destroyOnClose
        >
          <Table
            dataSource={[...(selectedCompanyPayments || [])].sort((a, b) => {
              const dateA = new Date(a.dateOfPayment || a.createdAt || 0).getTime();
              const dateB = new Date(b.dateOfPayment || b.createdAt || 0).getTime();
              return dateA - dateB;
            })}
            rowKey={(record) => record.id}
            pagination={false}
            scroll={{ x: "max-content" }}
            columns={[
              {
                title: <span style={{ whiteSpace: "nowrap" }}>S.No</span>,
                key: "serial",
                width: 70,
                align: "center",
                render: (text, record, index) => index + 1,
              },
              {
                title: <span style={{ whiteSpace: "nowrap" }}>Payment Type</span>,
                dataIndex: "paymentType",
                key: "paymentType",
                width: 140,
                render: (paymentType) => <span style={{ whiteSpace: "nowrap" }}>{paymentType ? paymentType : "-"}</span>,
              },
              {
                title: <span style={{ whiteSpace: "nowrap" }}>Payment Mode</span>,
                dataIndex: "paymentMode",
                key: "paymentMode",
                width: 140,
                render: (paymentMode) => <span style={{ whiteSpace: "nowrap" }}>{paymentMode ? paymentMode : "-"}</span>,
              },
              {
                title: <span style={{ whiteSpace: "nowrap" }}>Bank Detail</span>,
                dataIndex: "bankDetails",
                key: "bankDetails",
                width: 170,
                render: (bank) => (
                  <span style={{ whiteSpace: "nowrap" }}>
                    {bank ? bank.name + "-" + bank.accountNumber : "-"}
                  </span>
                ),
              },
              {
                title: <span style={{ whiteSpace: "nowrap" }}>Collected Amount (₹)</span>,
                dataIndex: "collectedAmount",
                key: "collectedAmount",
                width: 150,
                render: (amt) => (
                  <span style={{ whiteSpace: "nowrap" }}>
                    {amt ? Number(amt).toLocaleString("en-IN") : "0"}
                  </span>
                ),
              },

              {
                title: <span style={{ whiteSpace: "nowrap" }}>Status</span>,
                dataIndex: "status",
                key: "status",
                width: 90,
                render: (status) => (
                  <span
                    style={{
                      color: status === "SUCCESS" ? "green" : "red",
                      fontWeight: 500,
                      whiteSpace: "nowrap",
                    }}
                  >
                    {status}
                  </span>
                ),
              },
              {
                title: <span style={{ whiteSpace: "nowrap" }}>Date</span>,
                key: "paymentDate",
                width: 160,
                render: (_, record) => {
                  const dateVal = record.dateOfPayment || record.createdAt;
                  const dateStr = dateVal ? moment(dateVal).format("DD/MM/YYYY, h:mm A") : "-";
                  return <span style={{ whiteSpace: "nowrap" }}>{dateStr}</span>;
                },
              },
              {
                title: <span style={{ whiteSpace: "nowrap" }}>Collected By</span>,
                key: "collectedBy",
                width: 160,
                render: (_, record) => {
                  const empName =
                    record.collectedBy?.employeeName ||
                    record.EmployeeProfile?.employeeName ||
                    record.employee?.profile?.employeeName ||
                    record.employee?.employeeName ||
                    (typeof record.collectedBy === "string" ? record.collectedBy : null);
                  if (!empName) return "-";
                  const formatted = empName
                    .toLowerCase()
                    .split(" ")
                    .map((word) => (word ? word.charAt(0).toUpperCase() + word.slice(1) : ""))
                    .join(" ");
                 return <span style={{ whiteSpace: "nowrap" }}>{formatted}</span>;
                },
              },
            ]}
          />
        </Modal>
      )}

      {feedbackCallOpen &&
        <WrappedFeedbackCallModal
          open={feedbackCallOpen}
          close={() => {
            setFeedbackCallOpen(false);
            refreshData();
            setData({});
          }}
        />
      }

      {rtoDocumentOpen && (
        <RTODocumentModal
          open={rtoDocumentOpen}
          close={() => {
            setRtoDocumentOpen(false);
            setData({});
            if (refreshData) refreshData();
          }}
          data={data}
        />
      )}

      {customerLedgerOpen && selectedCustomer && (
        <LedgerModal
          visible={customerLedgerOpen}
          onCancel={() => {
            setCustomerLedgerOpen(false);
            setSelectedCustomer(null);
          }}
          data={selectedCustomer}
          type="CUSTOMERS"
          initialSubTab="BOOKING_REGISTER"
        />
      )}

      <PymidolBookingSyncModal
        visible={pymidolModalVisible}
        record={pymidolActiveRecord}
        onClose={() => {
          setPymidolModalVisible(false);
          setPymidolActiveRecord(null);
        }}
        onSuccess={() => {
          if (refreshData) refreshData();
        }}
      />
    </div>
  );
}
